import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Common } from '@trimblemaps/trimblemaps-js';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AccountType, SubscriptionLevel, UserInfo } from '../auth/models/user';
import { AuthenticationService } from '../auth/services/authentication.service';
import { TidService } from '../auth/services/tid.service';

@Injectable({
  providedIn: 'root',
})
export class PromoAuthGuard implements CanActivate {
  constructor(
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tidService: TidService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const authToken = route.params.authToken;
    if (authToken) {
      const userObj: UserInfo = {
        promo: true,
        maxNumberOfUsers: 1,
        accountType: AccountType.PCMWEB,
        subscriptionLevel: SubscriptionLevel.PREMIUM,
        dataset: Common.DataVersion.NA,
        region: 'NA',
        remainingRoutes: -1,
        isInvoiced: false,
        creditExpiredDate: '9999-12-31T23:59:59.9999999',
        isTripDirectEnabled: false,
        netSuiteOnline: false,
        isMonthlyPaidCustomer: false,
        userName: environment.promo.userName,
        firstName: environment.promo.firstName,
        lastName: environment.promo.lastName,
        account: environment.promo.account,
        userId: environment.promo.userId,
        accountId: environment.promo.accountId,
        expired: false,
        expirationDate: null,
        roles: ['Company Administrator'],
        hasBillingIssue: false,
        authToken: authToken,
        currentTermsOfUseAccepted: true,
        id: 1,
        password: '',
        username: environment.promo.userName,
        accountName: environment.promo.account,
        email: environment.promo.userName,
        expiresAt: null,
        loggedInAt: new Date(),
        _jwtToken: null,
      };

      return this.authenticationService.getJwtToken(authToken).pipe(
        map((token) => {
          this.tidService.loginSuccess(userObj, token);
          return true;
        })
      );
    }
  }
}
